import React from 'react';
import { useConnectedServicesQuery } from '@hooks/connectedServices';
import { Loader } from '@components/ui/Loader';
import { NoServicesConnected } from './NoServicesConnected';
import InsightsAndAnalyticsLayout from './index';

export const InsightsAndAnalyticsRouter: React.FC = () => {
  const { data: services, isLoading } = useConnectedServicesQuery();

  if (isLoading) {
    return <Loader />;
  }

  const hasActiveServices = services && services.length > 0 && 
    services.some(service => service.status === 0);

  // No services: show welcome/onboarding page (full page)
  if (!hasActiveServices) {
    return <NoServicesConnected />;
  }

  // Has services: show normal layout with tabs
  return <InsightsAndAnalyticsLayout />;
};
